import React, { useEffect } from 'react';
import { Dialog, DialogProps } from '@progress/kendo-react-dialogs';
import { NullableComponentRef, setAttribute } from '@utils/automation-test-helpers';

interface ConfirmationDialogProps extends DialogProps {
    'data-testid': string;
}

const CoreDialog = ({ 'data-testid': dataTestId, minWidth = 600, children, ...rest }: ConfirmationDialogProps) => {
    const ref = React.useRef<NullableComponentRef>(null);

    useEffect(() => setAttribute(ref, 'data-testid', dataTestId));

    return (
        <Dialog closeIcon={false} minWidth={minWidth} ref={ref} {...rest}>
            {children}
        </Dialog>
    );
};

export default CoreDialog;
